<template>
  <div
    class="skeleton-item-row tw-flex tw-items-center tw-gap-3 tw-p-3"
    tabindex="-1"
    aria-hidden="true"
  >
    <!-- Icon skeleton -->
    <q-skeleton
      type="circle"
      size="18px"
      :animation="animation"
      class="tw-shrink-0"
    />

    <!-- Content area -->
    <div class="tw-min-w-0 tw-flex-1">
      <!-- Primary text skeleton -->
      <q-skeleton
        type="text"
        :width="primaryWidth"
        :animation="animation"
        class="tw-mb-1"
      />

      <!-- Secondary text skeleton (optional) -->
      <q-skeleton
        v-if="showSecondary"
        type="text"
        width="60%"
        :animation="animation"
        class="tw-opacity-60"
        height="12px"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, withDefaults } from 'vue';

interface Props {
  showSecondary?: boolean;
  disableAnimation?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showSecondary: false,
  disableAnimation: false,
});

const animation = computed(() => (props.disableAnimation ? 'none' : 'wave'));

// Vary widths slightly for more realistic look
const primaryWidth = computed(() => {
  const widths = ['70%', '80%', '65%', '75%'];
  return widths[Math.floor(Math.random() * widths.length)];
});
</script>

<style scoped lang="scss">
.skeleton-item-row {
  min-height: 44px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
